const init = () => {
  const infoIcon = document.querySelector('.p-info__icon');
  const infoFrame = document.querySelector('.p-info__main');

  const fadeoutIcon = () => {
    if(window.innerWidth < 992) {
      infoIcon.style.opacity = '0';
      infoIcon.style.visibility = 'hidden';
    }
  }

  infoFrame.addEventListener('click', fadeoutIcon);
  infoFrame.addEventListener('touchstart', fadeoutIcon);
};

export {
    init,
};
